import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';

const isValidTime = (timeString) => {
  if (!timeString) {
    return false;
  }
  return /^([01]\d|2[0-3]):([0-5]\d)$/.test(timeString);
};

function TimePickerField({ value, onChange }) {
  const handleChange = (nextValue) => {
    if (!nextValue) {
      onChange('');
      return;
    }

    if (typeof nextValue === 'string') {
      if (isValidTime(nextValue)) {
        onChange(nextValue);
      }
      return;
    }

    if (nextValue instanceof Date && !Number.isNaN(nextValue.getTime())) {
      const hours = String(nextValue.getHours()).padStart(2, '0');
      const minutes = String(nextValue.getMinutes()).padStart(2, '0');
      onChange(`${hours}:${minutes}`);
    }
  };

  return (
    <TimePicker
      onChange={handleChange}
      value={value || null}
      format="HH:mm"
      disableClock
      clearIcon={null}
      clockIcon={null}
      locale="ar-IQ"
      className="clock-time-picker"
      maxDetail="minute"
      hourPlaceholder="ساعة"
      minutePlaceholder="دقيقة"
      amPmAriaLabel="حدد الفترة"
    />
  );
}

export default TimePickerField;

